import { CreateNewProjectThemeModeConfig } from './types';

const dark: CreateNewProjectThemeModeConfig = {
  createNewProject: {},
};

export default dark;
